var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-card-widget", { attrs: { title: "Dashboard" } }, [
        _c(
          "div",
          { attrs: { slot: "widget-content" }, slot: "widget-content" },
          [_c("app-timeline", { attrs: { itens: _vm.timelineItens } })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }